/* eslint-disable camelcase */
import {
  Card,
  Switch,
  Button,
  Tooltip,
  RadioGroup,
  Radio,
  NumericInput,
  Popover,
  Icon,
  Collapse
} from '@blueprintjs/core'
import React, { useState, useEffect, useCallback, useMemo } from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { useLocation } from 'react-router-dom'
import { BoxClass } from '../../../helper/classes'
import { OverlayProps } from '../../../helper/configs'
import { globalOnDemandVars } from '../../../helper/context'
import produce from 'immer'
import screenfull from 'screenfull'
import fire from '../../../../assets/images/fire.gif'
import ExternalLink from '../../commonInterface/externalLink'
import InPopover from '../../commonInterface/inPopover'
import { Trans, useTranslation } from 'react-i18next'

function LearningTricksAddOn () {
  const { t } = useTranslation()

  const [dontCheckAnswersBoolean, setDontCheckAnswersBoolean] = useState(globalOnDemandVars.learningTrickBooleans().dontCheckAnswers)
  const onChange0 = useCallback(
    () => {
      const newBoolean = !dontCheckAnswersBoolean
      setDontCheckAnswersBoolean(newBoolean)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.dontCheckAnswers = newBoolean
      }))
    },
    [dontCheckAnswersBoolean]
  )

  // const [fullScreenBoolean, setFullScreenBoolean] = useState(globalOnDemandVars.learningTrickBooleans().fullScreen)
  // const onChange1 = useCallback(
  //   () => {
  //     const newBoolean = !fullScreenBoolean
  //     setFullScreenBoolean(newBoolean)
  //     globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
  //       draft.fullScreen = newBoolean
  //     }))
  //   },
  //   [fullScreenBoolean]
  // )
  // const location = useLocation()
  // useEffect(() => {
  //   if (location.pathname === '/memorizing') {
  //     if (fullScreenBoolean) {
  //       screenfull.request()
  //     } else {
  //       screenfull.exit()
  //     }
  //   }
  // }, [fullScreenBoolean, location.pathname])

  const [intermittentReinforcementBoolean, setIntermittentReinforcementBoolean] = useState(globalOnDemandVars.learningTrickBooleans().intermittentReinforcement.active)
  const onChange2 = useCallback(
    () => {
      const newBoolean = !intermittentReinforcementBoolean
      setIntermittentReinforcementBoolean(newBoolean)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.intermittentReinforcement.active = newBoolean
      }))
    },
    [intermittentReinforcementBoolean]
  )
  const [intermittentReinforcementSound, setIntermittentReinforcementSound] = useState(globalOnDemandVars.learningTrickBooleans().intermittentReinforcement.sound)
  const onChange2_1 = useCallback(
    () => {
      const newBoolean = !intermittentReinforcementSound
      setIntermittentReinforcementSound(newBoolean)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.intermittentReinforcement.sound = newBoolean
      }))
    },
    [intermittentReinforcementSound]
  )

  const [obfuscationBoolean, setObfuscationBoolean] = useState(globalOnDemandVars.learningTrickBooleans().obfuscation)
  const onChange3 = useCallback(
    () => {
      const newBoolean = !obfuscationBoolean
      setObfuscationBoolean(newBoolean)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.obfuscation = newBoolean
      }))
    },
    [obfuscationBoolean]
  )

  const [earlyShortBreakBoolean, setEarlyShortBreakBoolean] = useState(globalOnDemandVars.learningTrickBooleans().earlyShortBreak)
  const onChange4 = useCallback(
    () => {
      const newBoolean = !earlyShortBreakBoolean
      setEarlyShortBreakBoolean(newBoolean)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.earlyShortBreak = newBoolean
      }))
    },
    [earlyShortBreakBoolean]
  )

  const [breakScheduleBoolean, setBreakScheduleBoolean] = useState(globalOnDemandVars.learningTrickBooleans().breakSchedule.active)
  const [breakScheduleMode, setBreakScheduleMode] = useState(globalOnDemandVars.learningTrickBooleans().breakSchedule.mode)
  const onChange5 = useCallback(
    () => {
      const newBoolean = !breakScheduleBoolean
      setBreakScheduleBoolean(newBoolean)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.breakSchedule.active = newBoolean
      }))
      if (newBoolean) {
        globalOnDemandVars.set_breakScheduleMode(breakScheduleMode)
      } else {
        globalOnDemandVars.set_breakScheduleMode(false)
      }
    },
    [breakScheduleBoolean, breakScheduleMode]
  )
  const onChange5_1 = useCallback(
    (e) => {
      const newValue = e.currentTarget.value
      setBreakScheduleMode(newValue)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.breakSchedule.mode = newValue
      }))
      globalOnDemandVars.set_breakScheduleMode(newValue)
    },
    []
  )
  const [learningTimeFor52, setLearningTimeFor52] = useState(globalOnDemandVars.learningTrickBooleans().breakSchedule.learningTimeFor52)
  const onChange5_2 = useCallback(
    (newValue) => {
      setLearningTimeFor52(newValue)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.breakSchedule.learningTimeFor52 = newValue
      }))
    },
    []
  )

  const [learningTimeForPomodoro, setLearningTimeForPomodoro] = useState(globalOnDemandVars.learningTrickBooleans().breakSchedule.learningTimeForPomodoro)
  const onChange5_3 = useCallback(
    (newValue) => {
      setLearningTimeForPomodoro(newValue)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.breakSchedule.learningTimeForPomodoro = newValue
      }))
    },
    []
  )
  const [shortBreakForPomodoro, setShortBreakForPomodoro] = useState(globalOnDemandVars.learningTrickBooleans().breakSchedule.shortBreakForPomodoro)
  const onChange5_4 = useCallback(
    (newValue) => {
      setShortBreakForPomodoro(newValue)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.breakSchedule.shortBreakForPomodoro = newValue
      }))
    },
    []
  )
  const [longBreakForPomodoro, setLongBreakForPomodoro] = useState(globalOnDemandVars.learningTrickBooleans().breakSchedule.longBreakForPomodoro)
  const onChange5_5 = useCallback(
    (newValue) => {
      setLongBreakForPomodoro(newValue)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.breakSchedule.longBreakForPomodoro = newValue
      }))
    },
    []
  )
  const [countForPomodoro, setCountForPomodoro] = useState(globalOnDemandVars.learningTrickBooleans().breakSchedule.countForPomodoro)
  const onChange5_6 = useCallback(
    (newValue) => {
      setCountForPomodoro(newValue)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.breakSchedule.countForPomodoro = newValue
      }))
    },
    []
  )

  const [ambientSoundBoolean, setAmbientSoundBoolean] = useState(globalOnDemandVars.learningTrickBooleans().ambientSound.active)
  const [ambientSoundMode, setAmbientSoundMode] = useState(globalOnDemandVars.learningTrickBooleans().ambientSound.mode)
  const onChange6 = useCallback(
    () => {
      const newBoolean = !ambientSoundBoolean
      setAmbientSoundBoolean(newBoolean)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.ambientSound.active = newBoolean
      }))
      if (newBoolean) {
        globalOnDemandVars.set_ambientSoundMode(ambientSoundMode)
      } else {
        globalOnDemandVars.set_ambientSoundMode(0)
      }
    },
    [ambientSoundBoolean, ambientSoundMode]
  )
  const onChange6_1 = useCallback(
    (e) => {
      const newValue = e.currentTarget.value
      setAmbientSoundMode(newValue)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.ambientSound.mode = newValue
      }))
      if (ambientSoundBoolean) {
        globalOnDemandVars.set_ambientSoundMode(newValue)
      }
    },
    [ambientSoundBoolean]
  )

  const [dopamineBoostingBoolean, setDopamineBoostingBoolean] = useState(globalOnDemandVars.learningTrickBooleans().dopamineBoosting.active)
  const [dopamineBoostingSound, setDopamineBoostingSound] = useState(globalOnDemandVars.learningTrickBooleans().dopamineBoosting.sound)
  const onChange7 = useCallback(
    () => {
      const newBoolean = !dopamineBoostingBoolean
      setDopamineBoostingBoolean(newBoolean)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.dopamineBoosting.active = newBoolean
      }))
      if (dopamineBoostingSound) {
        globalOnDemandVars.set_dopamineBoostingSound(newBoolean)
      }
    },
    [dopamineBoostingBoolean, dopamineBoostingSound]
  )
  const onChange7_1 = useCallback(
    () => {
      const newBoolean = !dopamineBoostingSound
      setDopamineBoostingSound(newBoolean)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.dopamineBoosting.sound = newBoolean
      }))
      globalOnDemandVars.set_dopamineBoostingSound(newBoolean)
    },
    [dopamineBoostingSound]
  )
  // -----------------------------------------------------------------------------------------------------------

  const onActivateAll = useCallback(
    () => {
      setDontCheckAnswersBoolean(true)
      // setFullScreenBoolean(true)
      setIntermittentReinforcementBoolean(true)
      setObfuscationBoolean(true)
      setEarlyShortBreakBoolean(true)
      setBreakScheduleBoolean(true)
      setAmbientSoundBoolean(true)
      setDopamineBoostingBoolean(true)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.dontCheckAnswers = true
        // draft.fullScreen = true
        draft.intermittentReinforcement.active = true
        draft.obfuscation = true
        draft.earlyShortBreak = true
        draft.breakSchedule.active = true
        draft.ambientSound.active = true
        draft.dopamineBoosting.active = true
      }))
      globalOnDemandVars.set_ambientSoundMode(ambientSoundMode)
      globalOnDemandVars.set_breakScheduleMode(breakScheduleMode)
    }, [ambientSoundMode, breakScheduleMode]
  )
  const onDeactivateAll = useCallback(
    () => {
      setDontCheckAnswersBoolean(false)
      // setFullScreenBoolean(false)
      setIntermittentReinforcementBoolean(false)
      setObfuscationBoolean(false)
      setEarlyShortBreakBoolean(false)
      setBreakScheduleBoolean(false)
      setAmbientSoundBoolean(false)
      setDopamineBoostingBoolean(false)
      globalOnDemandVars.set_learningTrickBooleans(produce(globalOnDemandVars.learningTrickBooleans(), draft => {
        draft.dontCheckAnswers = false
        // draft.fullScreen = false
        draft.intermittentReinforcement.active = false
        draft.obfuscation = false
        draft.earlyShortBreak = false
        draft.breakSchedule.active = false
        draft.ambientSound.active = false
        draft.dopamineBoosting.active = false
      }))
      globalOnDemandVars.set_ambientSoundMode(0)
      globalOnDemandVars.set_breakScheduleMode(false)
    }, []
  )

  // -----------------------------------------------------------------------------------------------------------

  const allActivated = useMemo(() => ((dontCheckAnswersBoolean && intermittentReinforcementBoolean && obfuscationBoolean && earlyShortBreakBoolean && breakScheduleBoolean && ambientSoundBoolean && dopamineBoostingBoolean)), [ambientSoundBoolean, breakScheduleBoolean, dontCheckAnswersBoolean, dopamineBoostingBoolean, earlyShortBreakBoolean, intermittentReinforcementBoolean, obfuscationBoolean])

  return (
    <div css={css`width: 100%; padding: 0 1em 0 1em;
//background-image: url(${fire}); background-size: auto 110%; background-position: bottom; background-repeat: no-repeat;
//& .activeLine {
//  display: flex;
//  position: relative;
//}
& > * {
  margin-bottom: 1em;
  display: block;
}
& .bp3-card {
  position: relative;
  color: var(--reverseColor);
  background-color: var(--baseColor);
  display: flex;
  justify-content: space-between;
}
& .switchAndLabel {
  display: flex;
  justify-content: space-between;
}
& .bp3-switch {
  margin-right: 1em;
  margin-top: 0.1em;
  margin-bottom: 0;
}
& .bp3-card .bp3-switch {
}
& .labelText {
  margin-left: 1.5em;
  word-break: break-word;
  font-weight: bold;
}
& .buttonDiv {
  flex-grow: 1;
}
& .helpButton {
  float: right;
}
& .bp3-control-indicator {
  cursor: inherit !important;
}
& .indent {
  padding-left: 2.25em;
  padding-right: 2.25em;
}
& .bp3-numeric-input input {
  width: var(--s5) !important;
}
& .soundButton {
  position: absolute;
  top: 8px;
  left: 0;
}
& .head {
  font-weight: bold;
  text-align: center;
}
.bp3-numeric-input .bp3-button-group.bp3-vertical > .bp3-button {
  box-shadow: none;
}
`}>
      <Popover {...OverlayProps} targetTagName={'div'} position={'top'} content={<InPopover>
        {t('explanationForLearningTricks.1')}
        <br />{t('explanationForLearningTricks.2')}
        <br />{t('explanationForLearningTricks.3')}
        <br />
        <Trans i18nKey={'explanationForLearningTricks.4'}>Click <ExternalLink url={'https://learnobit.postach.io/post/differences-from-other-sr-tools-in-lo-s-learning-course'}>here</ExternalLink> for those.)</Trans>
      </InPopover>}>
        <div css={css`font-size: 1.5em; font-weight: bold; text-align: center; margin-bottom: 0.67rem; &:hover { cursor: pointer; } `}>{t('Learning Tricks')}</div>
      </Popover>

      <div css={css`text-align: center; padding-left: 1rem;`}>
        <Switch label={allActivated ? t('Deactivate All') : t('Activate All')} checked={allActivated} onChange={allActivated ? onDeactivateAll : onActivateAll} alignIndicator={'right'} inline />
      </div>

      <Tooltip {...OverlayProps} targetTagName={'div'} position={'top'}
        content={<div>{t('explanationForLearningTricks.5')}</div>}>
        <Card className='mini'>
          <div className={'labelText'}>
            {t('explanationForLearningTricks.7')}
          </div>
          <Switch checked={dontCheckAnswersBoolean} onChange={onChange0} inline />
        </Card>
      </Tooltip>

      {/* <Card className='mini'> */}
      {/*  <div className={'activeLine'}> */}
      {/*    <Switch className='pixelCursor redBackground2' checked={fullScreenBoolean} onChange={onChange1} /> */}
      {/*    <div className={'labelText'}> */}
      {/*      Full Screen */}
      {/*    </div> */}
      {/*    <div className={'buttonDiv'}> */}
      {/*      <Tooltip popoverClassName={`pixelFont ${fullScreenBoolean ? 'redBackground3' : ''}`} {...OverlayProps} targetClassName={'helpButton'} position={'top'} */}
      {/*        content={'Forces the window to be full screen during courses'}><Button icon={'help'} intent={fullScreenBoolean ? 'danger' : 'none'} minimal /></Tooltip> */}
      {/*    </div> */}
      {/*  </div> */}
      {/* </Card> */}

      <Tooltip {...OverlayProps} targetTagName={'div'} position={'top'}
        content={<div>
          {t('explanationForLearningTricks.8')}
          <br />{t('explanationForLearningTricks.9')}</div>}>
        <Card className={'mini'}>
          <div css={css`display: flex;`}>
            <Tooltip {...OverlayProps} targetClassName={'soundButton'} content={intermittentReinforcementSound ? t('Turn Off Sound') : t('Turn on Sound')} position={'left'}>
              <Button minimal icon={intermittentReinforcementSound ? 'volume-up' : 'volume-off'} onClick={onChange2_1} />
            </Tooltip>
            <div className='labelText'>
              {t('explanationForLearningTricks.10')}
            </div>
          </div>
          <Switch checked={intermittentReinforcementBoolean} onChange={onChange2} />
        </Card>

        {/* <div className='indent activeLine'> */}
        {/*  <Switch className='pixelCursor redBackground2' checked={intermittentReinforcementBoolean && intermittentReinforcementSound} onChange={onChange2_1} disabled={!intermittentReinforcementBoolean} /> */}
        {/*  <div className='labelText'> */}
        {/*    Sound */}
        {/*  </div> */}
        {/* </div> */}
      </Tooltip>

      <Tooltip {...OverlayProps} targetTagName={'div'} position={'top'}
        content={<div>{t('explanationForLearningTricks.11')}
          <br />{t('explanationForLearningTricks.12')}</div>}>
        <Card className='mini'>
          <div className='labelText'>
            {t('explanationForLearningTricks.13')}
          </div>
          <Switch checked={obfuscationBoolean} onChange={onChange3} />
        </Card>
      </Tooltip>

      {/* <Card className='mini' style={{ background: earlyShortBreakBoolean ? '#F55656' : undefined, color: earlyShortBreakBoolean ? 'white' : undefined }}> */}
      {/*  <div className={'activeLine'}> */}
      {/*    <Switch className='pixelCursor redBackground2' checked={earlyShortBreakBoolean} onChange={onChange4} /> */}
      {/*    <div className='labelText'> */}
      {/*      Early Short Break */}
      {/*    </div> */}
      {/*    <div className='buttonDiv'> */}
      {/*      <Tooltip popoverClassName={`pixelFont ${earlyShortBreakBoolean ? 'redBackground3' : ''}`} {...OverlayProps} targetClassName={'helpButton'} position={'top'} */}
      {/*        content={<div>Insert short breaks during courses */}
      {/*          <br />(Research shows that these kinds of breaks boost learning)</div>}><Button icon={'help'} intent={earlyShortBreakBoolean ? 'danger' : 'none'} minimal /></Tooltip> */}
      {/*    </div> */}
      {/*  </div> */}
      {/* </Card> */}

      <Card className='mini' css={css`flex-direction: column;`}>

        <div className='head'>{t('explanationForLearningTricks.14')}</div>

        <Tooltip {...OverlayProps} targetTagName={'div'} position={'top'}
          content={<div>{t('explanationForLearningTricks.15')}
            <br />{t('explanationForLearningTricks.16')}</div>}>
          <div className={'switchAndLabel'} css={css`position: relative; margin-top: var(--s-2); margin-bottom: var(--s-2);`}>
            <div className={'labelText'} css={css`font-weight: bold;`}>
              {t('explanationForLearningTricks.17')}
            </div>
            <Switch checked={earlyShortBreakBoolean} onChange={onChange4} />
          </div>
        </Tooltip>

        <Tooltip targetTagName={'div'} {...OverlayProps} position={'top'}
          content={<div>{t('explanationForLearningTricks.18')}
            <br />{t('explanationForLearningTricks.19')} </div>}>
          <div className={'switchAndLabel'} css={css`position: relative;`}>
            <div className={'labelText'} css={css`font-weight: bold;`}>
              {t('explanationForLearningTricks.20')}
            </div>
            <Switch checked={breakScheduleBoolean} onChange={onChange5} />
          </div>
        </Tooltip>

        <Collapse isOpen={breakScheduleBoolean}>

          <RadioGroup selectedValue={breakScheduleMode} onChange={onChange5_1}
            css={css`display: flex; flex-direction: column; 
margin-top: var(--s-2); margin-left: 1.5em; margin-right: 24px;`}>
            <Radio label={t('explanationForLearningTricks.21')} value={'52/17'} alignIndicator={'right'} disabled={false} />
            <Radio label={t('explanationForLearningTricks.22')} value={'pomodoro'} alignIndicator={'right'} />
          </RadioGroup>

          <div css={css`margin-left: 1.5em; margin-right: 24px;`}>
            {breakScheduleMode === '52/17' ? (
              <div css={css`& > * {
                display: flex;
                justify-content: space-between;
                margin-bottom: var(--s-2);
              }`}>
                <div>
                  {t('explanationForLearningTricks.23')}
                  <NumericInput clampValueOnBlur intent={'primary'} min={1} value={learningTimeFor52}
                    onValueChange={onChange5_2} />
                </div>
                <div>
                  {t('explanationForLearningTricks.24')}
                  <div className={`bp3-control-group bp3-numeric-input`}>
                    <div className={`bp3-input-group bp3-intent-primary`}>
                      <input type='text' className='bp3-input' css={css`padding-right: 10px;`} value={(learningTimeFor52 * (17 / 52)).toFixed(2)} />
                    </div>
                  </div>
                </div>
              </div>
            ) : (breakScheduleMode === 'pomodoro' ? (
              <div css={css`& > * {
                display: flex;
                justify-content: space-between;
                margin-bottom: var(--s-2);
              } `}>
                <div>
                  {t('explanationForLearningTricks.23')}
                  <NumericInput clampValueOnBlur intent={'primary'} min={1} value={learningTimeForPomodoro}
                    onValueChange={onChange5_3} />
                </div>
                <div>
                  {t('explanationForLearningTricks.25')}
                  <NumericInput clampValueOnBlur intent={'primary'} min={1} value={shortBreakForPomodoro}
                    onValueChange={onChange5_4} />
                </div>
                <div>
                  {t('explanationForLearningTricks.26')}
                  <NumericInput clampValueOnBlur intent={'primary'} min={1} value={countForPomodoro}
                    onValueChange={onChange5_6} />
                </div>
                <div>
                  {t('explanationForLearningTricks.27')}
                  <NumericInput clampValueOnBlur intent={'primary'} min={1} value={longBreakForPomodoro}
                    onValueChange={onChange5_5} />
                </div>
              </div>
            ) : null)}
          </div>
        </Collapse>
      </Card>

      <Tooltip {...OverlayProps} targetTagName={'div'} position={'top'}
        content={t('explanationForLearningTricks.35')}>
        <Card className='mini' css={css`display: block !important;`}>
          <div className={'switchAndLabel'}>
            <div className='labelText'>
              {t('explanationForLearningTricks.28')}
            </div>
            <Switch checked={ambientSoundBoolean} onChange={onChange6} inline />
          </div>

          <Collapse isOpen={ambientSoundBoolean}>
            <RadioGroup css={css`margin-left: 1.5em; margin-right: 24px; margin-top: var(--s-1);`}
              selectedValue={ambientSoundBoolean && ambientSoundMode} onChange={onChange6_1}>
              <Radio label={<span
                title={'Sci-fi Laboratory Ambience http://freesound.org/people/qubodup/sounds/212025 by Iwan ‘qubodup’ Gabovitch http://freesound.org/people/qubodup under CC-BY 3.0 License http://creativecommons.org/licenses/by/3.0/legalcode with sounds by wolick, swiftoid, Diboz'}>
                {t('explanationForLearningTricks.29')}
              </span>}
                value={'1'} alignIndicator={'right'} />
              <Radio label={t('explanationForLearningTricks.30')} value={'2'} alignIndicator={'right'} />
              <Radio label={t('explanationForLearningTricks.31')} value={'3'} alignIndicator={'right'} />
              <Radio label={t('explanationForLearningTricks.32')} value={'4'} alignIndicator={'right'} />
            </RadioGroup></Collapse>
        </Card>
      </Tooltip>

      <Tooltip targetTagName={'div'} {...OverlayProps} position={'top'}
        content={t('explanationForLearningTricks.33')}>
        <Card className='mini'>
          <div css={css`display: flex;`}>
            <Tooltip {...OverlayProps} targetClassName={'soundButton'} content={dopamineBoostingSound ? t('Turn Off Sound') : t('Turn on Sound')} position={'left'}>
              <Button minimal icon={dopamineBoostingSound ? 'volume-up' : 'volume-off'} onClick={onChange7_1} />
            </Tooltip>
            <div className='labelText'>
              {t('explanationForLearningTricks.34')}
            </div>
          </div>
          <Switch checked={dopamineBoostingBoolean} onChange={onChange7} />
        </Card>
      </Tooltip>

    </div>
  )
}

const LearningTricksAddOnBoxClass = new BoxClass(LearningTricksAddOn, 'Learning Tricks', null, 1, { order: -1, onlyForTheseLocations: ['/memorizingEnter', '/memorizing'], initialHeight: 300, letItBePixel: true, backgroundColor: 'red' })

export default LearningTricksAddOnBoxClass

export { LearningTricksAddOn }
